import React, { FC } from 'react';

import { Autocomplete, TextField } from '@mui/material';

import { PromoLoyaltyCustomRulePresented } from '~/services/PromoService';

interface LoyaltyPromoKeyOptionsSelectorProps {
  loyaltyPromoKeyOptions: Array<PromoLoyaltyCustomRulePresented>;
  isPromoLoyaltyKeyOptionsLoading: boolean;
  value: string;
  onChange: (value: string) => void;
  isErroring?: boolean;
}

const LoyaltyPromoKeyOptionsSelector: FC<LoyaltyPromoKeyOptionsSelectorProps> = ({
  loyaltyPromoKeyOptions,
  isPromoLoyaltyKeyOptionsLoading,
  value,
  onChange,
  isErroring = false,
}) => {
  if (isPromoLoyaltyKeyOptionsLoading || !loyaltyPromoKeyOptions?.length) {
    return null;
  }

  const options = loyaltyPromoKeyOptions;

  return (
    <Autocomplete
      value={value || ''}
      options={options.map((option) => option.promoKey)}
      getOptionLabel={(option) => {
        const optionData = options.find((opt) => opt.promoKey === option);
        return optionData?.promoKey || option;
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Loyalty Promo Key"
          helperText="Select the loyalty promo key for this promotion"
          error={isErroring}
        />
      )}
      onChange={(e: unknown, newValue: string | null) => {
        onChange(newValue || '');
      }}
    />
  );
};

export default LoyaltyPromoKeyOptionsSelector;
